import { useState } from "react";
import { Box, HStack, VStack } from "../../components/utils";
import BCHeader from "../../shared/BCHeader";
import ValuationTable from "./ValuationTable";
import BlackScholesTable from "./BlackScholesTable";
import { useValuationDetails } from "../../queries/Valuation";

function ValuationOverview() {
  const { data: _valuationData, isPlaceholderData } = useValuationDetails();
  const [view, setView] = useState<"valuation" | "black-scholes">("valuation");

  return (
    <VStack className={`gap-4  ${isPlaceholderData ? "loading" : ""} `}>
      <div className="flex items-baseline justify-between">
        <BCHeader
          className="items-baseline "
          bcTitle="Valuation Reports"
          bcDescription="Dive into valuation reports detailing the company's equity value over time. Valuation data from these reports will be used to show current price per share, growth and for compensation reporting"
        />
      </div>

      <Box className="border-b border-gray-200">
        <HStack className="gap-8">
          <div
            className={`pb-2 cursor-pointer font-medium text-sm ${
              view === "valuation"
                ? "text-[#003366] border-b-2 border-[#003366]"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setView("valuation")}
          >
            Valuation
          </div>
          <div
            className={`pb-2 cursor-pointer font-medium text-sm ${
              view === "black-scholes"
                ? "text-[#003366] border-b-2 border-[#003366]"
                : "text-gray-500 hover:text-gray-700"
            }`}
            onClick={() => setView("black-scholes")}
          >
            Black-Scholes
          </div>
        </HStack>
      </Box>

      <HStack className="flex flex-row w-full">
        {view === "valuation" ? <ValuationTable /> : <BlackScholesTable />}
      </HStack>
    </VStack>
  );
}

export default ValuationOverview;
